export default __webpack_public_path__ + "static/media/a021-viewmore-en.69c589d8.jpg";